import React from "react";
import { Link } from "react-router-dom";

const Landingpage = () => {
  // landing page overlay

  // white colored header, light blue zeus-language title

  // info block

  return (
    <div className>
      <div className="container">
        <div className="courtyard-container">
          <div className="courtyard-title"> ZEUS </div>
          <div className="courtyard-buttons">
            {/* <div className="vert-text">Documents</div> */}
            login
          </div>
        </div>
      </div>
      <a href="https://www.templegrid.ai" rel="noopener noreferrer">
        <div className="templeGrid-button">
          {/* <div className="vert-text">Documents</div> */}
          TempleGrid →
        </div>
      </a>
    </div>
  );
};

export default Landingpage;
